import cloneDeep from "lodash.clonedeep";
import find from "lodash.find";
import { ConvertTextInputToArray } from "./utils";

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const inputChangeHandler = (e, formValues, setFormValues) => {
  let inputName = e.target.name;
  let inputValue = "";
  if (e.target.type == "checkbox" && inputName == "Permission") {
    inputValue = e.target.checked;
    let value =
      e.target.value != "" &&
      e.target.value != null &&
      e.target.value != undefined &&
      typeof e.target.value == "string"
        ? e.target.value.trim()
        : e.target.value;

    var currentObj = cloneDeep(formValues);
    let valueArr = currentObj[inputName].value;
    if (!valueArr.includes(value)) {
      valueArr.push(value); //adding to array because value doesnt exists
    } else {
      valueArr.splice(valueArr.indexOf(value), 1); //deleting
    }
    currentObj[inputName].value = valueArr;
    currentObj[inputName].touched = true;
    currentObj[inputName].error = valueArr.length > 0 ? false : true;

    setFormValues(currentObj);
  } else if (e.target.type == "checkbox") {
    inputValue = e.target.checked;

    let finalObj = {
      ...formValues,
      [inputName]: {
        ...formValues[inputName],
        error: !inputValue,
        message: inputValue ? "" : formValues[inputName]["default_msg"],
        touched: true,
        value: inputValue,
      },
    };
    setFormValues(finalObj);
  } else {
    inputValue =
      e.target.value != undefined &&
      e.target.value != null &&
      e.target.value != ""
        ? e.target.value
        : "";

    if (
      formValues[inputName].type != undefined &&
      formValues[inputName].type == "percentage"
    ) {
      inputValue =
        parseFloat(e.target.value) > 100
          ? 100
          : parseFloat(e.target.value) < 0
          ? 0
          : e.target.value;
      //inputValue = parseFloat(e.target.value) < 0 ? 0 : e.target.value;
    }
    let finalObj = {
      ...formValues,
      [inputName]: {
        ...formValues[inputName],
        error: !inputValue,
        message: inputValue ? "" : formValues[inputName]["default_msg"],
        touched: true,
        value: inputValue,
      },
    };
    setFormValues(finalObj);
  }
};
export const checkAllRequiredFieldsFilled = (formValues, setContinueEnable) => {
  var validate = true;
  for (var k in formValues) {
    var info = formValues[k];
    if (
      (info.required == true &&
        (info.value == "" ||
          info.value == null ||
          info.value == false ||
          info.error == true)) ||
      (info.required == false &&
        info.value != "" &&
        info.value != null &&
        info.error == true)
    ) {
      var info = formValues[k];
      if (
        (k == "Margin" && info.value == "0") ||
        (k == "RevenueShare" && info.value == "0")
      ) {
        validate = true;
        continue;
      }
      validate = false;
      break;
    }
  }
  setContinueEnable(validate);
};
export const isFormValid = (
  formValues,
  setFormValues,
  specificCheck,
  extraParamsObj
) => {
  let formValueCloneObj = cloneDeep(formValues);
  //let formValueCloneObj = { ...formValues };
  let valid = true;
  for (let key in formValues) {
    if (
      specificCheck != null &&
      specificCheck != undefined &&
      specificCheck.length > 0
    ) {
      if (!specificCheck.includes(key)) {
        continue;
      }
    }
    let validationType = formValues[key].type;
    let inputValue =
      formValues[key].value != "" &&
      formValues[key].value != null &&
      formValues[key].value != undefined &&
      typeof formValues[key].value == "string"
        ? formValues[key].value.trim()
        : formValues[key].value;
    let isRequired = formValues[key].required;
    let defaultMsg = formValues[key].default_msg;
    let errorRetObj = validateField(
      validationType,
      inputValue,
      isRequired,
      defaultMsg,
      extraParamsObj
    );

    formValueCloneObj[key].error = errorRetObj.error;
    formValueCloneObj[key].message = errorRetObj.message;
    formValueCloneObj[key].touched = true;

    if (errorRetObj.error == true) {
      console.log("Error-1:", errorRetObj);
      valid = false;
    }
  }

  if (valid == true && formValues?.CountryWiseFloors?.length > 0) {
    {
      formValues.CountryWiseFloors.map((countryInfo, i) => {
        let countryvalidationType =
          formValues["CountryWiseFloors"][i]["Country"].type;

        let countryinputValue =
          formValues["CountryWiseFloors"][i]["Country"].value;
        let countryisRequired =
          formValues["CountryWiseFloors"][i]["Country"].required;

        let countrydefaultMsg =
          formValues["CountryWiseFloors"][i]["Country"].default_msg;

        let countryerrorRetObj = validateField(
          countryvalidationType,
          countryinputValue,
          countryisRequired,
          countrydefaultMsg,
          extraParamsObj
        );
        formValueCloneObj["CountryWiseFloors"][i]["Country"].error =
          countryerrorRetObj.error;
        formValueCloneObj["CountryWiseFloors"][i]["Country"].message =
          countryerrorRetObj.message;
        formValueCloneObj["CountryWiseFloors"][i]["Country"].touched = true;

        if (countryerrorRetObj.error == true) {
          console.log("Error-2:", countryerrorRetObj);
          valid = false;
          return false;
        }
      });
    }
  }

  if (valid == false) {
    setFormValues(formValueCloneObj);
  }
  return valid;
};
export const inputBlurHandler = (
  e,
  formValues,
  setFormValues,
  extraParamsObj
) => {
  e.preventDefault();
  let inputName = e.target.name;
  let validationType = formValues[inputName].type;
  let inputValue =
    formValues[inputName].value != "" &&
    formValues[inputName].value != undefined &&
    formValues[inputName].value != null &&
    typeof formValues[inputName].value == "string"
      ? formValues[inputName].value.trim()
      : formValues[inputName].value;
  let isRequired = formValues[inputName].required;
  let defaultMsg = formValues[inputName].default_msg;

  let errorRetObj = validateField(
    validationType,
    inputValue,
    isRequired,
    defaultMsg,
    extraParamsObj
  );

  let finalObj = {
    ...formValues,
    [inputName]: {
      ...formValues[inputName],
      error: errorRetObj.error,
      message: errorRetObj.message,
      touched: true,
      value: inputValue,
    },
  };
  setFormValues(finalObj);
};

export const validateField = (
  validationType,
  value,
  isRequired,
  defaultMsg,
  extraParamsObj
) => {
  let retObj = { error: false, message: "" };
  if (isRequired === false && (value == "" || value == null)) {
    return retObj;
  } else {
    switch (validationType) {
      case undefined:
        return retObj;

      case "email":
        if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = "Enter Email Address";
        } else if (!validateEmail(value)) {
          retObj.error = true;
          retObj.message = "Enter Valid Email Address (user@example.com)";
        } else {
          retObj.error = false;
          retObj.message = "";
        }
        return retObj;

      case "username":
        if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = "Enter Username";
        } else if (value.length < 4) {
          retObj.error = true;
          retObj.message = "Enter Username with minimum 4 characters";
        } else {
          retObj.error = false;
          retObj.message = "";
        }
        return retObj;

      case "password":
        if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = "Enter Password";
        } else if (value.length < 6) {
          retObj.error = true;
          retObj.message = "Enter Password with minimum 6 characters";
        } else {
          retObj.error = false;
          retObj.message = "";
        }
        return retObj;

      case "url":
        if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = "Enter Url";
        } else if (!ValidURL(value)) {
          retObj.error = true;
          retObj.message = "Enter Valid URL";
        } else {
          retObj.error = false;
          retObj.message = "";
        }
        return retObj;

      case "percentage":
        if (value == "0") {
          retObj.error = false;
          retObj.message = "";
        } else if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = defaultMsg;
        } else if (value > 100 || value < 0) {
          console.log("inside");
          retObj.error = true;
          retObj.message = "The Percentage value should be in between 0 to 100";
        } else {
          retObj.error = false;
          retObj.message = "";
        }
        return retObj;
      case "zero":
        retObj.error = false;
        retObj.message = "";
        return retObj;
      case "radio":
        retObj.error = false;
        retObj.message = "";
        return retObj;
      case "multi_url":
        if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = "Enter URL";
        } else {
          let valuesArray = ConvertTextInputToArray(value);
          if (valuesArray.length > 0) {
            let isValid = true;
            for (let i = 0; i < valuesArray.length; i++) {
              if (valuesArray[i] != "" && valuesArray[i] != null) {
                if (!isHttpsUrl(valuesArray[i])) {
                  isValid = false;
                  break;
                }
              }
            }
            if (!isValid) {
              retObj.error = true;
              retObj.message = "Please Enter Valid URL(s) starts with https://";
            }
          }
        }
      default:
        if (value == "" || value == null || value == false) {
          console.log("validationType:", validationType);
          retObj.error = true;
          retObj.message = defaultMsg;
        }
        return retObj;
    }
  }
};

export const searchObjFromArrayOfObjs = (source, searchObj) => {
  const res = find(source, searchObj);
  return res;
};

export const selectChangeHandler = (e, formValues, setFormValues) => {
  let inputName = e.target.name;
  let inputValue =
    e.target.value != undefined &&
    e.target.value != null &&
    typeof e.target.value == "string"
      ? e.target.value.trim()
      : e.target.value;

  let finalObj = {
    ...formValues,
    [inputName]: {
      ...formValues[inputName],
      error: inputValue == "" || inputValue == null ? true : false,
      message: inputValue ? "" : formValues[inputName]["default_msg"],
      touched: true,
      value: inputValue,
    },
  };

  setFormValues(finalObj);
};

export const multiSelectChangeHandler = (e, formValues, setFormValues) => {
  let inputName = e.target.name;
  let inputValue =
    e.target.value != undefined &&
    e.target.value != null &&
    typeof e.target.value == "string"
      ? e.target.value.trim()
      : e.target.value;

  let finalObj = {
    ...formValues,
    [inputName]: {
      ...formValues[inputName],
      error: inputValue == "" ? true : false,
      message: inputValue ? "" : formValues[inputName]["default_msg"],
      touched: true,
      value: inputValue,
    },
  };
  setFormValues(finalObj);
};

export const multiCheckBoxChangeHandler = (e, formValues, setFormValues) => {
  let inputName = e.target.name;
  let inputValue =
    e.target.value != undefined &&
    e.target.value != null &&
    typeof e.target.value == "string"
      ? e.target.value.trim()
      : e.target.value;

  let previewsValue =
    e.target.previewsValue != undefined && e.target.previewsValue != null
      ? e.target.previewsValue
      : [];
  let checked = e.target.checked;
  if (checked) {
    //   Add
    previewsValue.push(inputValue);
  } else {
    // Remove
    const index = previewsValue.indexOf(inputValue);
    if (index > -1) {
      // only splice array when item is found
      previewsValue.splice(index, 1); // 2nd parameter means remove one item only
    }
  }

  let finalObj = {
    ...formValues,
    [inputName]: {
      ...formValues[inputName],
      error:
        formValues[inputName].required == true && previewsValue.length <= 0
          ? true
          : false,
      message:
        formValues[inputName].required == true && previewsValue.length <= 0
          ? formValues[inputName]["default_msg"]
          : "",
      touched: true,
      value: previewsValue,
    },
  };
  setFormValues(finalObj);
};
export const ValidURL = (str) => {
  var regex =
    /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
  if (!regex.test(str)) {
    return false;
  } else {
    return true;
  }
};
export const isHttpsUrl = (url) => {
  const httpsRegex = /^https:\/\/|^HTTPS:\/\//;
  return httpsRegex.test(url);
};
